import { ADD_COLOR_SCHEME, CHANGE_COLOR, SELECT_TILE, SELECT_SAMPLE, CHANGE_COLORS, SELECT_COLOR } from './actionTypes'
import { ADD_COLOR, SELECT_PATH } from './actionTypes'

export const addColorScheme = ( id, colors ) => ({
	type: ADD_COLOR_SCHEME,
	selectedTile: id,
	colorScheme: colors
});

export const selectPath = ( id ) => ({
	type: SELECT_PATH,
	id
});

export const changeColor = ( id, color ) => ({
	type: CHANGE_COLOR,
	id,
	color
});

export const changeColors = ( colors ) => ({
	type: CHANGE_COLORS,
	colors
});

export const selectTile = ( id ) => ({
	type: SELECT_TILE,
	id
});

export const addColor = ( color ) => ({
	type: ADD_COLOR,
	color
});

export const selectSample = ( id ) => ({
	type: SELECT_SAMPLE,
	id
});

export const selectColor = ( id ) => ({
	type: SELECT_COLOR,
	id
});


// WEBPACK FOOTER //
// ./src/actions/index.js